






















import { Vue, Component } from 'vue-property-decorator'
@Component({
  name: 'FilesApp'
})
export default class extends Vue {
  showNav: boolean = true

  get editPage() {
    const activeArr: string[] = ['TradeVipBoard']
    return activeArr.includes(this.$route.name as string)
  }
}
